import { createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageResourceType } from '@/Enums/LanguageResourceType';
import { TranslationsApi } from '@/Api/Translations/TranslationsApi';
import { UpdateTranslationsRequest } from '@/Api/Translations/UpdateTranslationsRequest';
import { translationsEditorUtils } from '@/Pages/Administration/LanguageEditor/services/TranslationsEditor/utils';
import { TranslationModel } from '@/Models/TranslationModel';
import { RootState } from '@/Redux/RootReducer';

const load = createAsyncThunk('languageEditorPage/erp-system-translations/load', async () => {
  return TranslationsApi.getTranslations({ languageResource: LanguageResourceType.Erp });
}); // load

const syncTranslations = createAsyncThunk(
  'languageEditorPage/erp-system-translations/syncTranslations',
  async (_, thunkApi) => {
    // Get
    const { translations: newTranslations } = await TranslationsApi.getTranslationsFromOtherServer({
      languageResource: LanguageResourceType.Erp,
    });

    const {
      languageEditorPage: {
        erpTranslationsEditor: {
          translations: { items: oldTranslations },
        },
      },
    } = thunkApi.getState() as RootState;

    let updatedTranslations: TranslationModel[] = [];
    let updatedPaths: string[] = [];
    // Update
    const translations = oldTranslations.map((oldTranslation) => {
      const newTranslation = newTranslations.find((item) => item.key === oldTranslation.key);
      if (newTranslation) {
        const { translation, paths, updatedItems } = translationsEditorUtils.updateStateNested(
          oldTranslation,
          newTranslation,
        );
        updatedTranslations = [...updatedTranslations, ...updatedItems];
        updatedPaths = [...updatedPaths, ...paths];
        return translation;
      }

      return oldTranslation;
    });

    // Return new translations and keys array
    return {
      updatedTranslations,
      translations,
      updatedPaths,
    };
  },
);

const update = createAsyncThunk(
  'languageEditorPage/erp-system-translations/update',
  async (request: UpdateTranslationsRequest) => {
    return TranslationsApi.updateTranslations(request);
  },
); // update

export const asyncActions = {
  load,
  update,
  syncTranslations,
};
